import { useReadContract } from "wagmi";
import { erc20Abi } from "viem";
import type { TokenData } from "../types/staking";
import { publicClient } from "../lib/viem";
import { useEffect, useState } from "react";

export function useTokenData(tokenAddress: string) {
  const { data: wagmiName } = useReadContract({
    address: tokenAddress as `0x${string}`,
    abi: erc20Abi,
    functionName: "name"
  });

  const { data: wagmiSymbol } = useReadContract({
    address: tokenAddress as `0x${string}`,
    abi: erc20Abi,
    functionName: "symbol"
  });

  const { data: wagmiTotalSupply } = useReadContract({
    address: tokenAddress as `0x${string}`,
    abi: erc20Abi,
    functionName: "totalSupply"
  });

  const { data: wagmiDecimals } = useReadContract({
    address: tokenAddress as `0x${string}`,
    abi: erc20Abi,
    functionName: "decimals"
  });

  const [name, setName] = useState<string | undefined>(wagmiName);
  const [symbol, setSymbol] = useState<string | undefined>(wagmiSymbol);
  const [totalSupply, setTotalSupply] = useState<bigint | undefined>(wagmiTotalSupply);
  const [decimals, setDecimals] = useState<number | undefined>(wagmiDecimals);

  useEffect(() => {
    async function fetchData() {
      try {
        if (!wagmiName) {
          const result = await publicClient.readContract({
            address: tokenAddress as `0x${string}`,
            abi: erc20Abi,
            functionName: "name"
          });
          setName(result as string);
        }

        if (!wagmiSymbol) {
          const result = await publicClient.readContract({
            address: tokenAddress as `0x${string}`,
            abi: erc20Abi,
            functionName: "symbol"
          });
          setSymbol(result as string);
        }

        if (!wagmiTotalSupply) {
          const result = await publicClient.readContract({
            address: tokenAddress as `0x${string}`,
            abi: erc20Abi,
            functionName: "totalSupply"
          });
          setTotalSupply(result as bigint);
        }

        if (!wagmiDecimals) {
          const result = await publicClient.readContract({
            address: tokenAddress as `0x${string}`,
            abi: erc20Abi,
            functionName: "decimals"
          });
          setDecimals(result as number);
        }
      } catch (error) {
        console.error("Error fetching token data:", error);
      }
    }

    if (!wagmiName || !wagmiSymbol || !wagmiTotalSupply || !wagmiDecimals) {
      fetchData();
    }
  }, [wagmiName, wagmiSymbol, wagmiTotalSupply, wagmiDecimals, tokenAddress]);

  return {
    data: name && symbol && totalSupply && decimals
      ? {
          name,
          symbol,
          totalSupply,
          decimals,
          contractAddress: tokenAddress
        }
      : undefined,
    isLoading: !name || !symbol || !totalSupply || !decimals
  };
}